window.SwalConfirmButtonText = 'Bevestigen';
window.SwalCancelButtonText = 'Annuleren';